/*
 * Htmx init
 *
 * Initialise htmx
 */

import PubSub from 'pubsub-js';
import lazySizes from 'lazysizes';
import animateScrollTo from 'animated-scroll-to';

export default class HtmxInit {

    constructor() {

        // htmx config - https://htmx.org/docs/#config

        // log all events for debugging
        //htmx.logger = function(elt, event, data) {
        //    if(console) {
        //        console.log("INFO:", event, elt, data);
        //    }
        //}
        //htmx.logAll();

        // LazySizes: unveiling
        // Add a class to wrapping elements
        document.addEventListener('lazybeforeunveil', (e)=> {
            let img = e.target;
            let picture = img.closest('[data-unveil]');
            if (picture) {
                picture.classList.add('is-lazyloaded');
            }
        });

        // handle response error
        htmx.on('htmx:responseError', (event) => {
            // hard redirect to final path, to let Craft handle it
            let path = event.detail.pathInfo.finalRequestPath ?? event.detail.pathInfo.finalPath ?? null;
            if (path) {
                try {
                    let redirectUrl = new URL(path);
                    if (redirectUrl) {
                        if (redirectUrl.origin === window.location.origin) {
                            window.location.href = path;
                        }
                    }
                } catch (e) {
                    // ignore
                }
            }
        });

        // handle swap error
        htmx.on('htmx:swapError', (event) => {
            // hard redirect to final path, to let Craft handle it
            let path = event.detail.pathInfo.finalRequestPath ?? event.detail.pathInfo.finalPath ?? null;
            if (path) {
                try {
                    let redirectUrl = new URL(path);
                    if (redirectUrl) {
                        if (redirectUrl.origin === window.location.origin) {
                            window.location.href = path;
                        }
                    }
                } catch (e) {
                    // ignore
                }
            }
        });

        htmx.on('htmx:beforeSwap', (event) => {
            PubSub.publish('htmx:beforeSwap', event);
            // disable smooth scrolling for 'main' element swaps
            if (event.target.id === 'main') {
                htmx.config.scrollBehavior = 'auto';
                htmx.config.defaultSettleDelay = 0;
            }
        });

        htmx.on('htmx:afterSwap', (event) => {
            PubSub.publish('htmx:afterSwap', event);

        });

        htmx.on('htmx:afterSettle', (event) => {
            PubSub.publish('htmx:afterSettle', event);

            // re-enable smooth scrolling, if it was disabled
            if (event.target.id === 'main') {
                setTimeout(() => {
                    htmx.config.scrollBehavior = 'smooth';
                    htmx.config.defaultSettleDelay = 20;
                    // make sure we scroll to top
                    animateScrollTo(document.body);
                }, 100);
            }
        });

        htmx.on('htmx:historyRestore', (event) => {

            // Refresh context, since <main> element itself isn't replaced when history restored
            // This can be referenced in CSS to specify styles for a given context
            /*
            if (event.detail.path) {
                let mainElt = document.getElementsByTagName("main")[0];
                const root = location.protocol + '//' + location.host;
                let url = root + event.detail.path;
                try {
                    let urlObj = new URL(url);
                    let path = urlObj.pathname.replace(/^\/|\/$/g, '');
                    mainElt.setAttribute('data-context', path);
                } catch (e) {}
            }
             */

            // LazySizes: check size of lazyloaded images with size="auto"
            // @see https://github.com/aFarkas/lazysizes#lazysizesautosizercheckelems
            // Only seems to be needed for Safari (BFCache bug?)
            lazySizes.autoSizer.checkElems();

            PubSub.publish('htmx:historyRestore', event);

        });

        htmx.on('htmx:beforeHistorySave', (event) => {
            PubSub.publish('htmx:beforeHistorySave', event);
        });

        htmx.on('htmx:pushedIntoHistory', (event) => {
            PubSub.publish('htmx:pushedIntoHistory', event);
        });

        htmx.on('htmx:historyCacheMiss', (event) => {
            PubSub.publish('htmx:historyCacheMiss', event);
        });

        htmx.on('htmx:afterOnLoad', (event) => {
            PubSub.publish('htmx:afterOnLoad', event);
        });

        // This extension adds the X-Requested-With header to requests with the value "XMLHttpRequest".
        htmx.defineExtension('ajax-header', {
            onEvent: function (name, evt) {
                if (name === "htmx:configRequest") {
                    evt.detail.headers['X-Requested-With'] = 'XMLHttpRequest';
                }
            }
        });

    }
}